export default "__VITE_ASSET__bfa9a034__"